/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=5cd07aaa&scoped=true&"
import script from "./Head.vue?vue&type=script&lang=js&"
export * from "./Head.vue?vue&type=script&lang=js&"
import style0 from "./Head.vue?vue&type=style&index=0&id=5cd07aaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd07aaa",
  null
  
)

export default component.exports